import { render } from "./TarotCardSelectPageHeader.vue?vue&type=template&id=316c8166&scoped=true"
import script from "./TarotCardSelectPageHeader.vue?vue&type=script&lang=js"
export * from "./TarotCardSelectPageHeader.vue?vue&type=script&lang=js"

import "./TarotCardSelectPageHeader.vue?vue&type=style&index=0&id=316c8166&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-316c8166"]])

export default __exports__